import { render, staticRenderFns } from "./CiCountdown.vue?vue&type=template&id=ecbe439e&scoped=true&"
import script from "./CiCountdown.vue?vue&type=script&lang=js&"
export * from "./CiCountdown.vue?vue&type=script&lang=js&"
import style0 from "./CiCountdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CiCountdown.vue?vue&type=style&index=1&id=ecbe439e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbe439e",
  null
  
)

component.options.__file = "CiCountdown.vue"
export default component.exports